import simona from './avatars/simona.jpg';
import owocki from './avatars/owocki.jpg';
import evanm from './avatars/evanm.jpg';
import joannaL from './avatars/joannaL.jpg';
import daphneC from './avatars/daphneC.jpg';
import manuA from './avatars/manuA.jpg';
import vaughnM from './avatars/vaughnM.jpg';
import marcusA from './avatars/marcusA.png';
import rhysL from './avatars/rhysL.jpg';
import paulaB from './avatars/paulaB.jpg';
import andresV from './avatars/andresV.jpg';
import danielK from './avatars/danielK.jpg';
import glenW from './avatars/glenW.jpg';
import christineV from './avatars/christineV.jpg';
import aaronS from './avatars/aaronS.jpg';
import guoL from './avatars/guoL.jpg';
import shreyJ from './avatars/shreyJ.jpg';
import pujaO from './avatars/pujaO.jpg';
import abbeyT from './avatars/abbeyT.jpg';
import kasiaS from './avatars/kasiaS.jpg';
import camilaR from './avatars/camilaR.jpg';
import naderB from './avatars/naderB.png';
import fabianV from './avatars/fabianV.jpg';
import manasiV from './avatars/manasiV.png';
import julianB from './avatars/julianB.jpg';
import harshR from './avatars/harshR.jpg';
import jahedM from './avatars/jahedM.jpg';
import lindaX from './avatars/lindaX.jpg';
import lefterisK from './avatars/lefterisK.png';
import awaS from './avatars/awaS.jpg';
import evinM from './avatars/evinM.jfif';
import dennisonB from './avatars/dennisonB.jfif';
import jamesW from './avatars/jamesW.jpg';
import krisD from './avatars/krisD.jpg';
import rahulK from './avatars/rahulK.jpg';
import pabloS from './avatars/pabloS.jpg';
import johnP from './avatars/johnP.png';
import holkeB from './avatars/holkeB.jpg';
import marekO from './avatars/marekO.jpg';
import poojaS from './avatars/poojaS.jpg';
import reneP from './avatars/reneP.png';
import liviaD from './avatars/liviaD.jpg';
import johnH from './avatars/johnH.jpg';
import ryanC from './avatars/ryanC.jpg';
import marcJ from './avatars/marcJ.jpg';
import michaelF from './avatars/michaelF.jpg';
import paulK from './avatars/paulK.jpg';
import tylerG from './avatars/tylerG.jpg';
import lauraM from './avatars/lauraM.jpg';
import vincentW from './avatars/vincentW.jpg';
import eugeneL from './avatars/eugeneL.jpg';
import ericN from './avatars/ericN.jpg';
import dannyZ from './avatars/dannyZ.jpg';
import shivaniM from './avatars/shivaniM.jfif';
import leaB from './avatars/leaB.jpg';
import alanR from './avatars/alanR.jpg';
import androsW from './avatars/androsW.jpg';
import aleksandraS from './avatars/aleksandraS.jpg';
import danielU from './avatars/danielU.jpg';
import annaK from './avatars/annaK.jpg';
import scottM from './avatars/scottM.jpeg';
import jonnyH from './avatars/jonnyH.jpg';
import carlF from './avatars/carlF.jpg';

export const speakersArray = [
  {
    name: `Simona\nPop`,
    company: 'Schelling Point Content Curator',
    twitter: 'https://twitter.com/Sim_Pop',
    avatar: simona
  },
  {
    name: 'Kevin\nOwocki',
    company: 'supermodular.xyz',
    twitter: 'https://twitter.com/owocki',
    avatar: owocki
  },
  {
    name: 'Abbey\nTitcomb',
    company: 'Radicle',
    twitter: 'https://twitter.com/abbey_titcomb',
    avatar: abbeyT
  },
  {
    name: 'Kasia\nSitkiewicz',
    company: 'Github',
    twitter: 'https://twitter.com/Calikasia',
    avatar: kasiaS
  },
  {
    name: 'Camila\nRamos',
    company: 'Fuel Labs',
    twitter: 'https://twitter.com/camiinthisthang',
    avatar: camilaR
  },
  {
    name: 'Nader\nDabit',
    company: 'DevDAO',
    twitter: 'Twitter.com/dabit3',
    avatar: naderB
  },
  {
    name: 'Eric\nNakagawa',
    company: 'Celo',
    twitter: 'https://twitter.com/ericnakagawa',
    avatar: ericN
  },
  {
    name: 'Fabian\nVogelsteller',
    company: 'LUKSO',
    twitter: 'https://twitter.com/feindura',
    avatar: fabianV
  },
  {
    name: 'Glen\nWeyl',
    company: 'RadicalxChange',
    twitter: 'https://twitter.com/glenweyl',
    avatar: glenW
  },
  {
    name: 'Danny\nZuckerman',
    company: 'Ceramic',
    twitter: 'https://twitter.com/dazuck',
    avatar: dannyZ
  },
  {
    name: 'Manasi\nVora',
    company: 'Skynet',
    twitter: 'https://twitter.com/manasilvora',
    avatar: manasiV
  },
  {
    name: 'Shivani\nMitra',
    company: 'MOCA',
    twitter: 'https://mobile.twitter.com/shivani_3000',
    avatar: shivaniM
  },
  {
    name: 'Julian\nBrangold',
    company: 'CruptoArg',
    twitter: 'https://twitter.com/julianbrangold',
    avatar: julianB
  },
  {
    name: 'Stefany\nCuervo',
    company: 'Colombian Artist',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Bertie\nLumsden',
    company: 'ArtDAO',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Rico\nSerna',
    company: 'Chimbites',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Harsh\nRajat',
    company: 'EPNS',
    twitter: 'https://twitter.com/harshrajat',
    avatar: harshR
  },
  {
    name: 'Jahed\nMomand',
    company: 'Cerulean Ventures',
    twitter: 'https://twitter.com/againstutopia',
    avatar: jahedM
  },
  {
    name: 'Linda\nXie',
    company: 'Scalar Capital',
    twitter: 'https://twitter.com/ljxie',
    avatar: lindaX
  },
  {
    name: 'Lefteris\nKarapetsas',
    company: 'Rotki',
    twitter: 'https://twitter.com/lefterisjp',
    avatar: lefterisK
  },
  {
    name: 'Scott\nMoore',
    company: 'Gitcoin',
    twitter: 'https://twitter.com/notscottmoore',
    avatar: scottM
  },
  {
    name: 'Awa\nSun Yin',
    company: 'Anoma',
    twitter: 'https://twitter.com/awasunyin',
    avatar: awaS
  },
  {
    name: 'Jonny\nHowle',
    company: 'Disco',
    twitter: 'https://twitter.com/jonnyhowle?s=21&t=72YDAmCKDGGXlTNLzYtxIQ',
    avatar: jonnyH
  },
  {
    name: 'Carl\nFairclough',
    company: 'Disco',
    twitter: 'https://twitter.com/carlfairclough?s=21&t=72YDAmCKDGGXlTNLzYtxIQ',
    avatar: carlF
  },
  {
    name: 'Dennison\nBertram',
    company: 'Tally',
    twitter: 'https://twitter.com/dennisonbertram',
    avatar: dennisonB
  },
  {
    name: 'James\nWaugh',
    company: 'fireeyes',
    twitter: 'https://twitter.com/blockchainjames',
    avatar: jamesW
  },
  {
    name: 'Kris\nDecoodt',
    company: 'Gitcoin',
    twitter: 'https://twitter.com/krrisis',
    avatar: krisD
  },
  {
    name: 'Rahul\nKothari',
    company: 'Reddit',
    twitter: 'https://twitter.com/omw_to_the_moon',
    avatar: rahulK
  },
  {
    name: 'Pablo\nSabbatella',
    company: 'Defy Education',
    twitter: 'https://twitter.com/pablosabbatella',
    avatar: pabloS
  },
  {
    name: 'Aaron\nSoskin',
    company: 'govrn.io',
    twitter: 'https://twitter.com/AaronSoskin',
    avatar: aaronS
  },
  {
    name: 'John\nPaller',
    company: 'Opolis',
    twitter: 'https://twitter.com/pallerjohn',
    avatar: johnP
  },
  {
    name: 'Paula\nBerman',
    company: 'RadicalxChange',
    twitter: 'https://twitter.com/_paulaberman',
    avatar: paulaB
  },
  {
    name: 'Andrés\nVelásquez',
    company: 'Fundación Karisma',
    twitter: 'https://twitter.com/Karisma',
    avatar: andresV
  },
  {
    name: 'Daniel\nKnobelsdorf',
    company: 'RadicalxChange',
    twitter: 'https://twitter.com/DanielKnobelsd1',
    avatar: danielK
  },
  {
    name: 'Michael\nFreedman',
    company: 'Microsoft',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Christine\nVandevoorde',
    company: 'govrn.io',
    twitter: 'https://twitter.com/TinaVandev',
    avatar: christineV
  },
  {
    name: 'Guo\nLiu',
    company: 'Matters Lab',
    twitter: 'https://twitter.com/_GuoLiu',
    avatar: guoL
  },
  {
    name: 'Shrey\nJain',
    company: 'Microsoft',
    twitter: 'https://twitter.com/shreyjaineth',
    avatar: shreyJ
  },
  {
    name: 'Puja\nOhlhaver',
    company: 'Flashbots',
    twitter: 'https://twitter.com/pujaohlhaver',
    avatar: pujaO
  },
  {
    name: 'Evan\nMiyazono',
    company: 'Protocol Labs',
    twitter: 'https://twitter.com/emiyazono',
    avatar: evanm
  },
  {
    name: 'Holke\nBrammer',
    company: 'Protocol Labs',
    twitter: 'https://twitter.com/holkeb',
    avatar: holkeB
  },
  {
    name: 'Joanna\nLiang',
    company: 'JSquare',
    twitter: 'https://twitter.com/joanna_jsquare',
    avatar: joannaL
  },
  {
    name: 'Anna\nKryukova',
    company: 'Celo',
    twitter: 'https://twitter.com/annaalexak',
    avatar: annaK
  },
  {
    name: 'Marek\nOlszewski',
    company: 'Celo/cLabs',
    twitter: 'https://twitter.com/marek_',
    avatar: marekO
  },
  {
    name: 'Matthew\nFrehlich',
    company: 'Protocol Labs',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Daphne\nCharles',
    company: 'Kiwi Labs',
    twitter: 'https://twitter.com/Daphachar',
    avatar: daphneC
  },
  {
    name: 'Pooja\nShah',
    company: 'Tephra Labs',
    twitter: 'https://twitter.com/pooja_eth',
    avatar: poojaS
  },
  {
    name: 'Juan\nGuillen',
    company: 'MakerDAO',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Rene\nPinnell',
    company: 'Artizen Fund',
    twitter: 'https://twitter.com/rjpinnell',
    avatar: reneP
  },
  {
    name: 'Vaughn\nMcKenzie-Landell',
    company: 'Butter',
    twitter: 'https://twitter.com/vaughnmck',
    avatar: vaughnM
  },
  {
    name: 'Rhys\nLindmark',
    company: 'Roote/Web3 & Society',
    twitter: 'https://twitter.com/RhysLindmark',
    avatar: rhysL
  },
  {
    name: 'Manu\nAlzuru',
    company: 'DoinGud',
    twitter: 'https://twitter.com/ManuAlzuru',
    avatar: manuA
  },
  {
    name: 'Marcus\nAurelius',
    company: 'KlimaDAO',
    twitter: 'https://twitter.com/0xKlimaurelius',
    avatar: marcusA
  },
  {
    name: 'Livia\nDe',
    company: 'Commons Stack',
    twitter: 'https://twitter.com/_liviade',
    avatar: liviaD
  },
  {
    name: 'Erin\nMurphy',
    company: 'Topl',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Ester\nFonseca',
    company: 'Carbonfi',
    twitter: '',
    avatar: ''
  },
  {
    name: 'John\nHoopes',
    company: 'Toucan',
    twitter: 'https://twitter.com/johnx25bd',
    avatar: johnH
  },
  {
    name: 'Ryan\nChristoffersen',
    company: 'Regen',
    twitter: 'https://twitter.com/ryanchristo_',
    avatar: ryanC
  },
  {
    name: 'Lea\nBauer',
    company: 'Flow',
    twitter: 'https://twitter.com/leafbauer',
    avatar: leaB
  },
  {
    name: 'Marc\nJohnson',
    company: 'Moderator',
    twitter: 'https://twitter.com/marcjohnson518',
    avatar: marcJ
  },
  {
    name: 'Alan\nRansil',
    company: 'Filecoin Green',
    twitter: 'https://twitter.com/rransil',
    avatar: alanR
  },
  {
    name: 'Ana Maria\nMahecha',
    company: 'KokoDAO',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Andros\nWong',
    company: 'Wonder',
    twitter: 'https://twitter.com/0xAndros',
    avatar: androsW
  },
  {
    name: 'Aleksandra\nSmilek',
    company: 'Foresight',
    twitter: 'https://twitter.com/jed_voras',
    avatar: aleksandraS
  },
  {
    name: 'Daniel\nUribe',
    company: 'Genobank',
    twitter: 'https://twitter.com/duribeb',
    avatar: danielU
  },
  {
    name: 'Michael\nFischer',
    company: 'CurateDAO',
    twitter: 'https://twitter.com/0xMikeyF',
    avatar: michaelF
  },
  {
    name: 'Paul\nKohlhaas',
    company: 'Molecule',
    twitter: 'https://twitter.com/paulkhls',
    avatar: paulK
  },
  {
    name: 'Tyler\nGolato',
    company: 'Molecule',
    twitter: 'https://twitter.com/GolatoTyler',
    avatar: tylerG
  },
  {
    name: 'Carolina\nMenchaca',
    company: 'DeSci.World',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Laura\nMinquini',
    company: 'AthenaDAO',
    twitter: 'https://twitter.com/lauraminquini/',
    avatar: lauraM
  },
  {
    name: 'Oksana\nStanevich',
    company: 'MD, Researcher',
    twitter: '',
    avatar: ''
  },
  {
    name: 'Vincent\nWeisser',
    company: 'vitaDAO',
    twitter: 'https://twitter.com/vincentweisser',
    avatar: vincentW
  },
  // {
  //   name: 'Eugene\nLeventhal',
  //   company: 'SCRF',
  //   twitter: 'https://twitter.com/bbeats1',
  //   avatar: eugeneL
  // },
];